import { bokehTokens, bokehColorGroups } from './bokehTokens.js';
import { slate, grayscale, green, yellow, white, purple, blue } from './colors.js';

const semanticTokens = {
  colors: {
    "text-primary": {
      default: slate["900"],
      _dark: grayscale["0"]
    },
    "text-secondary": {
      default: slate["500"],
      _dark: grayscale["200"]
    },
    "background-primary": {
      default: grayscale["0"],
      _dark: grayscale["950"]
    },
    "background-secondary": {
      default: slate["50"],
      _dark: slate["800"]
    },
    surface: {
      default: grayscale["0"],
      _dark: "rgba(27,27,27,1)"
    },
    rainbow: {
      default: "linear-gradient(to right,#73D2F6,#10B5FC,#8BCF0D,#FFC34E,#FB8920,#FA4343,#9F3D5C,#503873)"
    },
    stroke: {
      default: "rgba(222,228,233,1)",
      _dark: "rgba(65,65,65,1)"
    },
    "status-positive": {
      default: green["500"],
      _dark: green["500"]
    },
    "status-negative": {
      default: "rgba(255, 0, 0, 1)",
      _dark: "rgba(255, 0, 0, 1)"
    },
    "status-warning": {
      default: yellow["500"],
      _dark: yellow["500"]
    },
    "fill-primary": {
      default: "rgba(37, 45, 53, 0.1)",
      _dark: "rgba(228, 233, 239, 0.1)"
    },
    "background-body": {
      default: white,
      _dark: "rgba(18, 18, 18, 1)"
    },
    "upsell-primary": {
      default: purple["400"],
      _dark: purple["400"]
    },
    "upsell-secondary": {
      default: purple["100"],
      _dark: purple["900"]
    },
    "input-border": {
      default: "rgba( 0, 0, 0, 0.25)",
      _dark: "rgba(255, 255, 255, 0.25)"
    },
    "input-border-hover": {
      default: "rgba(0, 0, 0, 0.5)",
      _dark: "rgba(255, 255, 255, 0.5)"
    },
    "focus-alt": {
      default: slate["900"],
      _dark: grayscale["50"]
    },
    focus: {
      default: blue["500"],
      _dark: blue["400"]
    },
    "button-secondary-default": {
      default: blue["200"],
      _dark: blue["300"]
    }
  },
  fontSizes: {
    "input-xl": "header-xl",
    "input-lg": "1.5rem",
    "input-md": "text",
    "input-sm": "text-sm",
    "input-xs": "text-xs"
  }
};
const combinedTokens = {
  ...bokehTokens,
  colors: {
    ...bokehColorGroups,
    ...bokehTokens.colors,
    ...semanticTokens.colors
  },
  fontSizes: {
    ...bokehTokens.fontSizes,
    ...semanticTokens.fontSizes
  }
};

export { combinedTokens, semanticTokens };
